import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import {
	DashboardCategories,
	DashboardCategoriesFetchDataMapping,
	DashboardCategoriesIconsMapping,
} from 'constants/balance.constants';
import { pagesEnum } from 'constants/ui.constants';
import { useEffect, useState } from 'react';
import { fetchCategoryData } from 'services/balances.service';
import { formatNumber } from 'components/FormCreatorComponent/helpers';

export const PageHeader = (props: { category: DashboardCategories; parent?: DashboardCategories }) => {
	const { category, parent } = props;
	const t = useAppSelector(selectTranslations);
	const pagePrefix = 'page.dashboard.dashboardBalances.';
	const theme = useTheme();
	const filters = useAppSelector((state) => state.dashboard.filters);
	const [loading, setLoading] = useState<boolean>(false);
	const dispatch = useAppDispatch();
	const [total, setTotal] = useState<string | undefined>(undefined);

	useEffect(() => {
		//get all related data by category
		//if (_.has(DashboardCategoriesFetchDataMapping, category as DashboardCategories)) {
		const api = _.get(DashboardCategoriesFetchDataMapping, category as DashboardCategories);
		const isDetailed = false;
		if (api && !loading) {
			if (category === DashboardCategories.MONTHLY_SUBSCRIPTIONS_BY_CUSTOMERS) {
				return;
			}
			setLoading(true);
			dispatch(fetchCategoryData({ name: api, data: { filters, isDetailed } }))
				.unwrap()
				.then((data) => {
					setLoading(false);
					let total;
					if (data) {
						switch (category) {
							case DashboardCategories.CUSTOMER_BALANCES:
							case DashboardCategories.CUSTOMER_BALANCES_DETAIL_BY_CUSTOMERS:
								setTotal(undefined);
								break;
							case DashboardCategories.PENDING_BALANCE:
								//setTotal('');
								break;
							case DashboardCategories.PAYMENT_FEES:
								if (!_.isNil(_.get(data, DashboardCategories.PAYMENT_FEES + '[0].' + 'totalFeesNis'))) {
									setTotal(
										'₪' +
											formatNumber(
												_.get(data, DashboardCategories.PAYMENT_FEES + '[0].' + 'totalFeesNis')
											)
									);
								}
								break;
							case DashboardCategories.CONVERSION_FEES:
								if (
									!_.isNil(_.get(data, DashboardCategories.CONVERSION_FEES + '[0].' + 'totalFeesNis'))
								) {
									setTotal(
										'₪' +
											formatNumber(
												_.get(
													data,
													DashboardCategories.CONVERSION_FEES + '[0].' + 'totalFeesNis'
												)
											)
									);
								}
								break;
							case DashboardCategories.MONTHLY_SUBSCRIPTIONS:
							//setTotal('');
						}
					}
				})
				.catch(() => setLoading(false));
		}
	}, [filters]);

	return (
		<Stack>
			<Stack flexDirection={'row'} justifyContent={'space-between'}>
				<Typography variant="pageTitle" display={'flex'} flexDirection={'row'} gap={2}>
					<img
						src={`/icons/${_.get(DashboardCategoriesIconsMapping, category)}.svg`}
						width={28}
						height={28}
						alt={category}
						style={{ opacity: parent ? 0.4 : 1 }}
					/>
					{parent && (
						<Box sx={{ opacity: 0.4 }}>{`${t(pagePrefix + parent)} ${
							!_.isNil(total) ? `(${total})` : ''
						} / `}</Box>
					)}
					{t(pagePrefix + category)}
					{!_.isNil(total) && !parent && <Box fontWeight={300}>({total})</Box>}
				</Typography>
				<Link style={{ color: theme.palette.root.formTitle }} to={'/' + pagesEnum.MAIN_DASHBOARD}>
					{t(pagePrefix + 'backToDashboard')}
				</Link>
			</Stack>
		</Stack>
	);
};
